<dialog-container>
    <toolbar-component color="primary">Create Guest</toolbar-component>
    <guest-form-component
        [requiresSubmit]="true"
        [submissionHandler]="createGuest"
        [guest]="guest"
    ></guest-form-component>
</dialog-container>
